import {
  CREDIT_NOTE_DOCUMENT_TYPE_CODE,
  GOODS_AND_SERVICE_CN_CODE,
  INVOICE_DOCUMENT_TYPE_CODE,
  OUT_OF_SCOPE_INVOICE_CODE,
} from '../constants/defaults';

export const isCommercialDocumentType = (code) =>
  code === INVOICE_DOCUMENT_TYPE_CODE || code === CREDIT_NOTE_DOCUMENT_TYPE_CODE;

export const isOutOfScopeDocumentType = (code) =>
  code === OUT_OF_SCOPE_INVOICE_CODE || code === GOODS_AND_SERVICE_CN_CODE;
